<template>
  <v-snackbar v-model="showError" top color="error" rounded="pill">
    {{ errorMessage }}

    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="removeErrors">
        {{ $t('text_close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    errorType: function () {
      const value = this.$store.getters.errorType
      if (value !== undefined && value !== null) {
        return this.$store.getters.errorType
      } else {
        return ''
      }
    },
    errorMessage: function () {
      const value = this.$store.getters.errorMessage
      if (value !== undefined && value !== null) {
        return this.$store.getters.errorMessage
      } else {
        return ''
      }
    },
    showError: {
      get() {
        const value = this.$store.getters.showError;
        if (value !== undefined && value !== null) {
          return true;
        } else {
          return false;
        }
      },
      set(newValue) {
        this.$store.commit('setShowError', newValue);
      }
    }
  },
  mounted() {
    setTimeout(this.removeErrors, 5000)
  },
  methods: {
    removeErrors() {
      this.$store.dispatch('removeErrors')
    }
  }
}
</script>
